import React, { useContext } from 'react'

import { Backdrop, CardBody, CardFooter, CardHeader, Sheet, Text } from '@vividseats/vivid-ui-kit'

import Breadcrumbs from '@/components/shared/breadcrumbs'
import DismissButton from '@/components/shared/modal/components/dismiss-button'
import productionsDetailsContext from '@/context/production-details'
import { ProductionLicensesProvider } from '@/context/production-licenses'

import CMSContent from '../cms-content'
import EventLineup from '../lineup'
import ModalLinks from '../modal-links'
import ResellerLicenses from '../reseller-licenses'

import moreInfoContext from './context'
import styles from './styles.module.scss'

const MoreInfoModal: React.FC = () => {
    const {
        selectors: { eventInfo },
    } = useContext(productionsDetailsContext)

    const {
        state: { isMoreInfoOpen },
        dispatch: { toggleMoreInfo },
    } = useContext(moreInfoContext)

    const id = 'more-info-modal'

    return (
        <>
            <Backdrop
                zIndex="sheet"
                data-testid={`${id}-backdrop`}
                isOpen={isMoreInfoOpen}
                onClick={() => toggleMoreInfo(false)}
            />
            <Sheet
                position="fixed"
                responsive
                className={styles.sheet}
                toggle={isMoreInfoOpen}
                data-testid={`${id}-sheet`}
                ssr
            >
                <CardHeader className={styles.cardHeader} data-testid={`${id}-header`}>
                    {eventInfo?.breadcrumbs && <Breadcrumbs links={eventInfo.breadcrumbs} />}
                    <Text as="h3" className={styles.headerText}>
                        {eventInfo?.mainPerformerName} at {eventInfo?.venueName}
                    </Text>
                </CardHeader>
                <CardBody className={styles.cardBody} data-testid={`${id}-body`}>
                    <EventLineup />
                    <CMSContent />
                    {eventInfo?.idLicenses && (
                        <ProductionLicensesProvider initialParams={{ id: eventInfo.idLicenses }}>
                            <ResellerLicenses />
                        </ProductionLicensesProvider>
                    )}
                    <ModalLinks />
                </CardBody>
                <CardFooter className={styles.cardFooter} data-testid={`${id}-footer`}>
                    <DismissButton id={id} onClick={() => toggleMoreInfo(false)} />
                </CardFooter>
            </Sheet>
        </>
    )
}

export default MoreInfoModal
